import { useEffect, useState } from "react";

import { useSelector } from "@jti/store/reduxHooks";

type UseOrderLimitData = {
  isOrderLimitError: boolean;
  maxOrderLimit: number;
  grandTotal: number;
  isOrderLimitAchieved: boolean;
};

export const useOrderLimit = (): UseOrderLimitData => {
  const grandTotal = useSelector((state) => state.cart.prices.data?.grandTotal.value) ?? 0;
  const shipping = useSelector((state) => state.cart.prices.data?.shipping?.value) ?? 0;
  const [limitMessageStatus, setLimitMessageStatus] = useState(false);
  const { is_order_limit_enabled: isLimitEnabled, order_limit_value: maxOrderLimit } = useSelector(
    (state) => state.cart.storeConfig
  );

  useEffect(() => {
    setLimitMessageStatus((grandTotal || 0) - (shipping || 0) > maxOrderLimit && isLimitEnabled);
  }, [grandTotal, shipping, maxOrderLimit, isLimitEnabled]);

  const isOrderLimitError = limitMessageStatus && isLimitEnabled;
  const isOrderLimitAchieved = isLimitEnabled && grandTotal - shipping > maxOrderLimit;

  return { isOrderLimitError, maxOrderLimit, grandTotal, isOrderLimitAchieved };
};
